import script from "./OkrElementsFormCustomFieldsHub.vue?vue&type=script&setup=true&lang=js"
export * from "./OkrElementsFormCustomFieldsHub.vue?vue&type=script&setup=true&lang=js"

import "./OkrElementsFormCustomFieldsHub.vue?vue&type=style&index=0&id=cb556448&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cb556448"]])

export default __exports__